var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',[_c('apexchart',{attrs:{"type":"line","options":_vm.themedChartOptions,"series":_vm.series,"height":_vm.customHeight}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }